<template>
    <div style="display: flex; flex-direction: column; align-items: center; padding: 2.25rem 5vw">
        <div style="text-align: left; width: 100%">
            <div class="el-icon-back cursor-pointer showPC" style="font-size: 1.5rem; line-height: 2rem; font-weight: bold; position: absolute; margin-left: -2rem" @click="onBack"></div>
            <div
                class="el-icon-back cursor-pointer showPhone"
                style="font-size: 1.5rem; line-height: 2rem; font-weight: bold; position: absolute; margin-left: calc(90vw - 1.5rem)"
                @click="onBack"
            ></div>
            <div style="font-size: 2rem; line-height: 2rem; font-weight: bold; color: #b62d2e">學習表現 Learning Performance</div>
            <div style="display: flex; margin-top: 0.5rem; margin-bottom: 1rem">
                <span style="width: 1rem; height: 1rem; background: #b62d2e; border-radius: 50%; margin-right: 1rem"></span>
                <span style="width: 1rem; height: 1rem; background: #de5934; border-radius: 50%; margin-right: 1rem"></span>
                <span style="width: 1rem; height: 1rem; background: #f1aa55; border-radius: 50%; margin-right: 1rem"></span>
            </div>
        </div>
        <div style="font-size: 2rem; line-height: 2rem; font-weight: bold; color: #b62d2e">
            學生 Student：<span style="color: #444444; font-weight: normal">{{ name }}</span>
        </div>

        <div class="model-box">
            <div
                :style="{
                    transform: isHomework ? 'translateX(100%)' : 'translateX(0%)',
                }"
                class="model-move"
            ></div>
            <div @click="isHomework = false" class="model-text cursor-pointer" :style="{ color: isHomework ? '#B62D2E' : 'white' }">冒險模式<br />Adventure Mode</div>
            <div @click="isHomework = true" class="model-text cursor-pointer" :style="{ color: isHomework ? 'white' : '#B62D2E' }">作業<br />Homework</div>
        </div>

        <div class="search-box">
            <el-row type="flex" align="bottom" :gutter="10" style="flex-wrap: wrap">
                <el-col :xs="12" :sm="5" :md="4" v-show="!isHomework">
                    <div class="input-title">年級 Grade</div>
                    <el-select @change="gradeChange" v-model="form.gradeId" clearable placeholder="全部 All" style="width: 100%">
                        <el-option v-for="(item, index) in grades" :key="index" :label="item.name" :value="item.id"> </el-option>
                    </el-select>
                </el-col>
                <el-col :xs="12" :sm="5" :md="4" v-show="!isHomework">
                    <div class="input-title">星星 Stars</div>
                    <el-select @change="starChange" v-model="form.star" clearable placeholder="全部 All" style="width: 100%">
                        <el-option v-for="(item, index) in 4" :key="index" :label="index" :value="index"> </el-option>
                    </el-select>
                </el-col>
                <el-col :sm="9" :md="6" v-show="!isHomework">
                    <div class="input-title">搜尋 Search</div>
                    <el-input class="search" @input="keywordChange" placeholder="搜尋課題關鍵字 Search Chapter keywords" v-model="form.keywords1" prefix-icon="el-icon-search"></el-input>
                </el-col>
                <el-col :xs="12" :sm="5" :md="4" v-show="isHomework">
                    <div class="input-title">開始日期 Start Date</div>
                    <el-date-picker align="center" v-model="form.startDate" type="date" placeholder="DD/MM/YY" format="dd/MM/yyyy" clearable style="width: 100%"> </el-date-picker>
                </el-col>
                <el-col :xs="12" :sm="5" :md="4" v-show="isHomework">
                    <div class="input-title">結束日期 End Date</div>
                    <el-date-picker align="center" v-model="form.endDate" type="date" placeholder="DD/MM/YY" format="dd/MM/yyyy" clearable style="width: 100%"> </el-date-picker>
                </el-col>
                <el-col :sm="9" :md="6" v-show="isHomework">
                    <div class="input-title">搜尋 Search</div>
                    <el-input class="search" @input="keywordChange" placeholder="搜尋作業關鍵字 Search Homework keywords" v-model="form.keywords2" prefix-icon="el-icon-search"></el-input>
                </el-col>
                <el-col :xs="12" :sm="5" :md="4" v-show="!isHomework">
                    <div class="input-title">語言 Language</div>
                    <el-select @change="langChange" v-model="form.lang1" clearable placeholder="全部 All" style="width: 100%">
                        <el-option v-for="(item, index) in langList" :key="index" :label="item" :value="index"> </el-option>
                    </el-select>
                </el-col>
                <el-col :xs="12" :sm="5" :md="4" v-show="isHomework">
                    <div class="input-title">語言 Language</div>
                    <el-select @change="langChange" v-model="form.lang2" clearable placeholder="全部 All" style="width: 100%">
                        <el-option v-for="(item, index) in langList" :key="index" :label="item" :value="index"> </el-option>
                    </el-select>
                </el-col>
                <el-col :md="{ span: 6, offset: 0 }" style="display: flex; padding-top: 0.625rem">
                    <button @click="search" class="security-button cursor-pointer" style="background-color: #fcc03a; margin-right: 10px; flex: 3">搜尋<br />Search</button>
                    <button @click="clearSearch" class="security-button cursor-pointer" style="flex: 4">清除篩選<br />Reset</button>
                </el-col>
            </el-row>
        </div>

        <div class="summary-box">
            <el-table class="is-topic" v-show="!isHomework" :data="topicData" style="width: 100%">
<!--                <el-table-column prop="gradeName" :label="'年級\nGrade'" width="140">-->
<!--                    <template slot-scope="{ row }">-->
<!--                        <span>{{ row.gradeName + " " + enName(row.gradeName) }}</span>-->
<!--                    </template>-->
<!--                </el-table-column>-->
                <el-table-column prop="name" :label="'課題\nChapter'" min-width="180"> </el-table-column>
                <el-table-column :label="'語言\nLanguage'" width="140">
                    <template slot-scope="{ row }">
                        <span>{{ langList[row.lang] }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="'練習\nExercise'" width="130">
                    <template slot-scope="{ row }">
                        <span>{{ row.practiseCompletedQuantity + "/" + row.practiseTotalQuantity }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="star" width="220" align="center">
                    <template slot="header">
                        <div style="display: flex;align-items:end;justify-content:center">
                            <div style="text-align: left;">{{'星星\nStars'}}</div>
                            <el-popover
                                placement="top"
                                width="auto"
                                trigger="hover"
                                popper-class="show-toolTip"
                                :visible-arrow="false">
                                <img src="@/assets/images/Help.png" slot="reference" style="margin-left:0.5rem;display:block" />
                                <div style="margin:auto">
                                    0 星 = 0 分<br />
                                    0 星 = 未作答<br />
                                    1 星 = 低過60分（1 - 60）<br />
                                    2 星 = 低過100分（61 - 99）<br />
                                    3 星 = 全對
                                </div>
                            </el-popover>
                        </div>
                      </template>
                    <template slot-scope="scope">
                        <img :src="scope.row.star > 0 ? require('@/assets/images/star-light.png') : require('@/assets/images/star-dark.png')" />
                        <img :src="scope.row.star > 1 ? require('@/assets/images/star-light.png') : require('@/assets/images/star-dark.png')" />
                        <img :src="scope.row.star > 2 ? require('@/assets/images/star-light.png') : require('@/assets/images/star-dark.png')" />
                    </template>
                </el-table-column>
            </el-table>
            <el-table class="is-homework" v-show="isHomework" :data="homeworkData" style="width: 100%">
                <el-table-column prop="number" :label="'作業\nHomework'" min-width="340"> </el-table-column>
                <el-table-column :label="'語言\nLanguage'" width="150">
                    <template slot-scope="{ row }">
                        <span>{{ langList[row.lang] }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="startDate" :label="'開始日期及時間\nStart Date and Time'" width="200" :formatter="startFormatter"> </el-table-column>
                <el-table-column prop="endDate" :label="'到期日期及時間\nEnd Date and Time'" width="200" :formatter="endFormatter"> </el-table-column>
                <el-table-column prop="completedAt" :label="'完成日期及時間\nFinish Date and Time'" width="200" :formatter="completedFormatter"> </el-table-column>
                <el-table-column :label="'分數\nScore'" width="140">
                    <template slot-scope="{ row }">
                        <span>{{ row.correctQuantity + "/" + row.totalQuantity }}</span>
                    </template>
                </el-table-column>
            </el-table>
            <Pagination
                v-show="!isHomework && total1 > 0"
                :small="$store.getters.isPC ? false : true"
                :total="total1"
                :autoScroll="false"
                :page.sync="listQ._page1"
                :limit.sync="listQ._limit"
                @pagination="getTopics"
                layout="pager"
            />
            <Pagination
                v-show="isHomework && total2 > 0"
                :small="$store.getters.isPC ? false : true"
                :total="total2"
                :autoScroll="false"
                :page.sync="listQ._page2"
                :limit.sync="listQ._limit"
                @pagination="getHomeworks"
                layout="pager"
            />
        </div>
    </div>
</template>

<script>
import { getGrades } from "@/api/grade";
import { getHomeworks } from "@/api/homework";
import { getTopics } from "@/api/topic";
import { formatDateTime, formatDate2 } from "@/filters";
import Pagination from "@/components/Pagination";
export default {
    components: { Pagination },
    name: "home",
    data() {
        return {
            id: null,
            name: null,
            gradeId: null,
            isHomework: false,
            total1: 0,
            total2: 0,
            form: {
                gradeId: null,
                star: null,
                keywords1: null,
                keywords2: null,
                startDate: null,
                endDate: null,
                lang1: null,
                lang2: null,
            },
            listQ: {
                _page1: 1,
                _page2: 1,
                _limit: 10, //20,
            },
            grades: [],
            topicData: [],
            homeworkData: [],
        };
    },
    watch: {
        "$store.getters.language": {
            handler() {
                //  this.getCarts()
                this.getGrades();

                this.$forceUpdate();
            },
            deep: true,
        },
    },
    created() {
        if (!this.isEmpty(this.$route.query.id)) this.id = Number(this.$route.query.id);
        if (!this.isEmpty(this.$route.query.studentName)) this.name = this.$route.query.studentName;
        if (!this.isEmpty(this.$route.query.gradeId)) {
            this.gradeId = Number(this.$route.query.gradeId);
            this.form.gradeId = this.gradeId;
        }
      if (!this.isEmpty(this.$route.query.studying)) {
        this.form.lang1 = Number(this.$route.query.studying);
        this.form.lang2 = Number(this.$route.query.studying);
      }
        this.initial();
    },
    methods: {
        initial() {
            this.getGrades();
            this.getHomeworks();
            this.getTopics();
        },
        startFormatter(row) {
            return formatDateTime(row.startDate) || "---";
        },
        endFormatter(row) {
            return formatDateTime(row.endDate) || "---";
        },
        completedFormatter(row) {
            return formatDateTime(row.completedAt) || "---";
        },
        enName(gradeName) {
            let enGradeList = {
                小一: "Primary One",
                小二: "Primary Two",
                小三: "Primary Three",
                小四: "Primary Four",
                小五: "Primary Five",
                小六: "Primary Six",
            };
            return enGradeList[gradeName];
        },
        getGrades() {
            getGrades().then((v) => {
                this.grades = v.data;
                this.$forceUpdate();
            });
        },
        getHomeworks() {
            let form = {
                studentId: this.id,
                gradeId: this.form.gradeId,
                startDate: formatDate2(this.form.startDate),
                endDate: formatDate2(this.form.endDate),
                keywords: this.form.keywords2,
                lang: this.form.lang2,
                _page: this.listQ._page2 - 1,
                _limit: this.listQ._limit,
            };
            getHomeworks(form).then((v) => {
                this.homeworkData = v.data;
                this.total2 = Number(v.headers["x-total-count"]);
            });
        },
        getTopics() {
            let form = {
                studentId: this.id,
                gradeId: this.form.gradeId,
                star: this.form.star,
                keywords: this.form.keywords1,
                lang: this.form.lang1,
                _page: this.listQ._page1 - 1,
                _limit: this.listQ._limit,
                orderBy: "number",
            };
            getTopics(form).then((v) => {
                this.topicData = v.data;
                this.total1 = Number(v.headers["x-total-count"]);
            });
        },
        gradeChange(id) {
            console.log(id);
        },
        starChange(value) {
            console.log(value);
        },
        langChange(lang) {
            console.log(lang);
        },
        keywordChange(str) {
            console.log(str);
        },
        search() {
            this.getTopics();
            this.getHomeworks();
        },
        clearSearch() {
            this.form.gradeId = "";
            this.form.star = "";
            this.form.keywords1 = "";
            this.form.startDate = "";
            this.form.endDate = "";
            this.form.keywords2 = "";
            this.form.lang1 = "";
            this.form.lang2 = "";
            let form = {
                studentId: this.id,
                // gradeId: this.gradeId,
                _page: 0,
                _limit: this.listQ._limit,
                orderBy: "number",
            };
            getTopics(form).then((v) => {
                this.topicData = v.data;
                this.total1 = Number(v.headers["x-total-count"]);
                this.listQ._page1 = 1;
            });
            getHomeworks(form).then((v) => {
                this.homeworkData = v.data;
                this.total2 = Number(v.headers["x-total-count"]);
                this.listQ._page2 = 1;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.model-box {
    display: flex;
    text-align: center;
    background: white;
    border: 1px #b62d2e solid;
    border-radius: 2rem;
    padding: 0.25rem;
    margin: 1rem;
    font-family: "GenSenRoundedTW", "Helvetica", "Arial";
    position: relative;
}
.model-move {
    position: absolute;
    //transition: transform 0.4s linear 0s;
    transform: translateX(0%);
    width: 10rem;
    height: 2.5rem;
    border-radius: 2rem;
    //mix-blend-mode:exclusion;
    //background:#49d2d1;//#00ffff;
    background: #b62d2e;
}
.model-text {
    padding: 0.25rem 0;
    width: 10rem;
    color: #b62d2e; //#ff0000;
    //mix-blend-mode:screen;
    z-index: 1;
}
.input-title {
    color: #8e8e8e;
    font-weight: 500;
    line-height: 1.6rem;
}
.security-button {
    //margin:1.25rem 0;
    border: 0.0625rem solid #fcc03a;
    background-color: #ffffff;
    font-weight: bold;
    font-size: 1rem;
    color: #444444;
    border-radius: 1.625rem;
    //line-height: 2.625rem;
    line-height: 1;
    height: 3.75rem;
}
.search-box {
    font-size: 0.875rem;
    width: 100%;
}
.summary-box {
    width: 100%;
    margin: 2rem 0;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.home-box {
    padding: 3.75rem 8.75rem;
}
/*在768 和991 像素之间的屏幕里，小屏幕，主要是PAD*/
@media (min-width: $minWidth) and (max-width: $maxWidth) {
    .home-box {
        padding: 2.75rem 4.75rem;
    }
}
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
    .home-box {
        padding: 1.25rem;
    }
}
::v-deep {
    .el-select .el-input .el-select__caret {
        color: #444444;
    }
    .el-input__prefix,
    .el-input__suffix {
        color: #444444;
    }
    .el-date-editor {
        .el-input__prefix {
            left: auto;
            right: 5px;
        }
        .el-input__suffix {
            right: 25px;
        }
    }
    .el-input__inner {
        //border-top-right-radius: 3.125rem;
        //border-bottom-right-radius: 3.125rem;
        border-radius: 0.625rem;
        //background-color: #fffbed;
        border: 0.0625rem solid #a1a1a1;
        padding-left: 0.5rem;
        height: 2.75rem;
        line-height: 2.75rem;
    }
    .search .el-input__inner {
        padding-left: 30px;
    }
    .el-icon-search {
        background: url("~@/assets/images/search.png") center center/contain no-repeat;
    }
    .el-icon-search:before {
        content: "";
    }
    .el-table {
        font-size: 1rem;
        /*th + th, td + td{
        margin-right:2rem;
      }*/
    }
    .el-table .cell {
        padding: 0;
    }
    .el-table th.el-table__cell > .cell {
        padding: 0;
        white-space: pre-wrap;
    }
    .el-table th {
        background: #fceedd;
        color: #444444;
        font-weight: 500;
    }
    .el-table th:first-child {
        padding-left: 6rem;
    }
    .el-table td:first-child {
        padding-left: 6rem;
    }
    .el-table.is-topic th:nth-child(5) {
        padding-right: 6rem;
    }
    .el-table.is-homework th:nth-child(6) {
        padding-right: 6rem;
    }
    .el-table td:last-child {
        padding-right: 6rem;
    }
}
</style>
